import { privateInstance } from "../configs";

export const customUnitApi = {
  async getCustomUnits() {
    const res = await privateInstance.get("/recipes/api/custom-unit/");
    return res.data;
  },
  async postCustomUnit(unit) {
    const res = await privateInstance.post("/recipes/api/custom-unit/", unit);
    return res.data;
  },
  async retrieveCustomUnit(id) {
    const res = await privateInstance.get(`/recipes/api/custom-unit/${id}/`);
    return res.data;
  },
  async patchCustomUnit(id, unit) {
    const res = await privateInstance.patch(
      `/recipes/api/custom-unit/${id}/`,
      unit
    );
    return res.data;
  },
  async deleteCustomUnit(id) {
    const res = await privateInstance.delete(`/recipes/api/custom-unit/${id}/`);
    return res.data;
  }
};
